import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.title = {
    as: "h1",
    variant: "h1",
    transform: "inherit",
    css: css`
        border-width: 20px;
        margin-bottom: 26px;
    `,
};

categoriesStyles.container = {
    css: css`
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid ${color("common.ui5")};
    `,
};

categoriesStyles.categoryNameLinkItem = {
    width: 12,
    css: css`
        padding-bottom: 10px;
    `,
};

categoriesStyles.categoryNameLink = {
    ...categoriesStyles.categoryNameLink,
    typographyProps: {
        ...categoriesStyles.categoryNameLink!.typographyProps,
        size: 19,
    },
};

categoriesStyles.subCategoryItem = {
    ...categoriesStyles.subCategoryItem,
    width: [12, 12, 6, 6, 6],
};

categoriesStyles.subCategoryLink = {
    ...categoriesStyles.subCategoryLink,
    typographyProps: {
        ...categoriesStyles.subCategoryLink!.typographyProps,
        size: 17,
    },
};
